import { FC, useMemo } from 'react';

import type { ArticleOnce } from '@/entities/article';

import styles from './articleOnceContent.module.scss';

interface ArticleOnceContentProps {
  value: ArticleOnce;
}

const ArticleOnceContent: FC<ArticleOnceContentProps> = (props) => {
  const { value } = props;

  const content = useMemo(() => {
    let result = value.text.replace(/<video\s+([^>]*)>/gi, (match, attrs) => {
      let newAttrs = attrs;

      if (!newAttrs.includes('playsinline')) {
        newAttrs += ' playsinline';
      }

      if (!newAttrs.includes('controls')) {
        newAttrs += ' controls';
      }

      if (newAttrs.includes('preload="metadata"')) {
        newAttrs = newAttrs.replace('preload="metadata"', 'preload="auto"');
      } else if (!newAttrs.includes('preload')) {
        newAttrs += ' preload="auto"';
      }

      newAttrs = newAttrs.replace(/src=(["'])(.*?)\1/gi, (srcMatch: string, quote: string, url: string) => {
        if (url.includes('#t=')) return srcMatch;
        return `src=${quote}${url}#t=0.1${quote}`;
      });

      const widthMatch = newAttrs.match(/\bwidth=["']?(\d+)(%?)["']?/i);
      if (widthMatch) {
        const maxWidthValue = widthMatch[2] === '%' ? `${widthMatch[1]}%` : `${widthMatch[1]}px`;
        const maxWidthStyle = `max-width:${maxWidthValue}`;
        const styleMatch = newAttrs.match(/\bstyle=["']([^"']*)["']/i);
        if (styleMatch) {
          const existingStyle = styleMatch[1].trim();
          const newStyle = existingStyle.includes('max-width')
            ? existingStyle.replace(/max-width\s*:\s*[^;]+;?/gi, `${maxWidthStyle};`).trim()
            : existingStyle
              ? `${existingStyle}; ${maxWidthStyle}`.trim()
              : maxWidthStyle;
          newAttrs = newAttrs.replace(/\bstyle=["'][^"']*["']/i, `style="${newStyle}"`);
        } else {
          newAttrs = `${newAttrs.trim()} style="${maxWidthStyle}"`;
        }
      }

      return `<video ${newAttrs}>`;
    });

    result = result.replace(/<img\s+([^>]*)>/gi, (match, attrs) => {
      const widthMatch = attrs.match(/\bwidth=["']?(\d+)(%?)["']?/i);
      if (!widthMatch) return match;
      const maxWidthValue = widthMatch[2] === '%' ? `${widthMatch[1]}%` : `${widthMatch[1]}px`;
      const maxWidthStyle = `max-width:${maxWidthValue}`;
      const styleMatch = attrs.match(/\bstyle=["']([^"']*)["']/i);
      if (styleMatch) {
        const existingStyle = styleMatch[1].trim();
        const newStyle = existingStyle.includes('max-width')
          ? existingStyle.replace(/max-width\s*:\s*[^;]+;?/gi, `${maxWidthStyle};`).trim()
          : existingStyle
            ? `${existingStyle}; ${maxWidthStyle}`.trim()
            : maxWidthStyle;
        return `<img ${attrs.replace(/\bstyle=["'][^"']*["']/i, `style="${newStyle}"`)} alt="">`;
      }
      return `<img ${attrs.trim()} style="${maxWidthStyle}" alt="">`;
    });

    result = result.replace(
      /<table([^>]*)>/gi,
      '<div class="article-table-scroll"><table$1>',
    );
    result = result.replace(/<\/table>/gi, '</table></div>');

    return result;
  }, [value.text]);

  return (
    <section className={styles.section}>
      <div
        dangerouslySetInnerHTML={{ __html: content }}
        className={styles.section__content}
      ></div>
    </section>
  );
};

export default ArticleOnceContent;
